import CallIcon from '@mui/icons-material/Call';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Spin from 'components/Spin';
import React, { useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { formatPhoneNumber, getName, stringAvatar } from 'utils';

const ContactsList = ({
  contacts,
  onLoadMore,
  hasMore,
  onClick,
  onHideDialer,
}) => {
  const handleScroll = (e) => {
    // hide dialer when scrolled 10px down
    if (e.target.scrollTop > 10) {
      onHideDialer();
    }
  };

  const items = contacts.map((contact) => {
    const name = getName(contact);
    return (
      <ListItem key={contact.hash}>
        <ListItemAvatar sx={{ minWidth: 45 }}>
          <Avatar
            src={contact.contact_image_full_url}
            {...stringAvatar(name, { width: 36, height: 36, fontSize: 24 })}
          />
        </ListItemAvatar>
        <ListItemText
          primary={name}
          primaryTypographyProps={{
            fontWeight: 500,
          }}
          secondary={formatPhoneNumber(contact.primary_phone)}
        />
        {contact.primary_phone && (
          <ListItemSecondaryAction>
            <IconButton onClick={() => onClick(contact)} color="success">
              <CallIcon />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItem>
    );
  });

  return (
    <List
      disablePadding
      sx={{ overflow: 'auto', flex: 1 }}
      onScroll={handleScroll}
    >
      <InfiniteScroll
        useWindow={false}
        pageStart={0}
        loadMore={onLoadMore}
        hasMore={hasMore}
        loader={
          <Box textAlign="center" p={2}>
            <Spin spinning />
          </Box>
        }
      >
        {items}
      </InfiniteScroll>
    </List>
  );
};

export default ContactsList;
